import { makeStyles } from '@mui/styles'
import { useTheme } from '@mui/material/styles'
import common from 'shared/styles'

const useStyles = makeStyles(() => {
    const theme = useTheme()

    return {
        root: {
            ...common.fullContainer,
            display: 'flex',
        },
        main: {
            ...theme.custom.dashBoardRoot,
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',
        },
        button: {
            ...theme.custom.button,
            padding: 0,
        },
    }
})

export default useStyles
